import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/shanna-teel-bio.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Shanna R. Teel, PhD" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Shanna R. Teel, PhD</h1>
        <div>
          <img
            src={Image}
            alt
            title="shanna-teel-bio"
            width={200}
            height={193}
            className="alignleft size-full wp-image-343"
            style={{ float: 'left' }}
          />
          <p />
          <p>
            Shanna R. Teel, PhD is a Senior Associate with Gómez &amp;
            Associates and the Founder and CEO of Dr. Shanna Teel &amp; Company,
            Inc., a Leadership and Talent Development Consulting Firm. In Dr.
            Teel’s career, she has over 15 years as a talent and performance
            management consultant and individual coaching for executives and
            managers in a wide array of organizations. Likewise, she has
            experience working within numerous organizations in several
            different positions. Some of these include: Partner and Executive
            Vice President for Executive Development Associates in Oklahoma
            City, Oklahoma; Partner and Executive Vice President for Jones &amp;
            Associates Consulting in San Diego, California and Senior Consultant
            for The Organizational Consulting Center at California School of
            Professional Psychology in San Diego, California.
          </p>
          <p>
            Shanna holds dual Ph.Ds. in Industrial Organizational Psychology and
            Clinical Psychology from Alliant International University (formerly
            California School of Professional Psychology). Likewise, she earned
            a Masters of Arts in Clinical Psychology also from Alliant
            International University. Her undergraduate work was a Bachelors of
            Science in Psychology from California State University- Bakersfield
            with a Minor in Spanish. In addition, Shanna did a Study Abroad
            Program in Madrid, Spain with the University of California San
            Diego.
          </p>
          <p>
            Dr. Teel consulting expertise specializes in the areas of leadership
            development, executive and management coaching, career development,
            strategic planning, conflict management, performance management
            systems design, communication skill development, negotiation and
            mediation, and business development. She has provided organization
            development consulting, team development, and individual coaching in
            the following organizations: Citigroup; Kodak; Nokia; Fugihunt, USA;
            Center for Naval Analysis; UBS Financial; Dow Chemical; Deloitte
            &amp; Touche; TA Instruments; Victoria’s Secret; Eiasi
            Pharmaceuticals; McDonald’s; St. Luke’s Health Network; Interwoven;
            ARM; Victoria’s Secret; Barclays Global Investors; Chesapeake
            Energy; Vitas Hospice; The Braille Institute; University of
            Oklahoma; Oklahoma Heart Hospital; University of California San
            Diego Hospital; Hasbro; Thomson Reuters.
          </p>
          <p>
            Dr. Teel has numerous certifications including: Executive Coach from
            the Executive College of Coaching; the Hogan Personality Inventory
            (HPI); Wonderlic Cognitive Ability Test; Communication Skills
            Profile; Myers-Briggs Type Indicator®, MBTI® (personality
            assessment); California Psychological Inventory™; FIRO-B™ (behavior
            assessment); and Customized 360-Degree Feedback Assessment
          </p>
          <p>
            Website:{' '}
            <a href="http://www.drshannateel.com/">www.drshannateel.com</a> |
            Phone: 781.249.7531 | Email:{' '}
            <a href="mailto:shanna@drshannateel.com">shanna@drshannateel.com</a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
